import * as React from 'react';
import AvatarEditor from 'react-avatar-editor';
import { Button } from '../Bootstrap';
import { NobleModal } from '../NobleModal';
import { ImageIcon } from './ImageIcon';
import './ImageCropModal.scss';

interface ImageCropModalProps {
  aspectRatio: number;
  sourceUrl: string;
  fileName: string;
  onCancel();
  onSave(image: File);
}

interface ImageCropModalState {
  dimensions?: {
    width: number;
    height: number;
  };
  scale: number;
}

const dataUriToFile = (dataUri: string, filename: string): File => {
  const binary = atob(dataUri.split(',')[1]);
  const array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }

  const blob = new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
  if (/Edge/.test(navigator.userAgent)) {
    (blob as any).lastModifiedDate = new Date();
    (blob as any).name = filename;
    return blob as any;
  } else {
    return new File([blob], filename);
  }
};

export class ImageCropModal extends React.PureComponent<ImageCropModalProps, ImageCropModalState> {
  public state: ImageCropModalState = {
    scale: 1,
  };

  public cropWrapperRef = React.createRef<any>();
  public editor = React.createRef<any>();

  componentDidMount() {
    if (this.cropWrapperRef.current) {
      const modalWidth = this.cropWrapperRef.current.offsetWidth;
      this.setState({
        dimensions: {
          width: modalWidth,
          height: (1 / this.props.aspectRatio) * modalWidth,
        },
      });
    }
  }

  onSubmit = () => {
    if (this.editor.current) {
      const canvasElement = this.editor.current.getImage();
      this.props.onSave(dataUriToFile(canvasElement.toDataURL('image/jpeg'), this.props.fileName));
    }
  };

  onChangeScale = (e) => {
    const { value } = e.target;
    this.setState({
      scale: Number(value),
    });
  };

  renderEditor = () => {
    if (this.state.dimensions) {
      return (
        <AvatarEditor
          ref={this.editor}
          image={this.props.sourceUrl}
          width={this.state.dimensions.width}
          height={this.state.dimensions.height}
          scale={this.state.scale}
          border={0}
          disableBoundaryChecks={false}
          crossOrigin='anonymous'
        />
      );
    }
  };

  render() {
    const dynamicStyle = this.state.dimensions ? { height: this.state.dimensions.height } : {};

    return (
      <NobleModal size='lg' isOpen={true} toggle={() => alert('')}>
        <NobleModal.Title title='Crop photo' />
        <div className='image-crop-modal-wrapper' style={dynamicStyle} ref={this.cropWrapperRef}>
          {this.renderEditor()}
        </div>
        <NobleModal.Body>
          <div className='image-crop-modal-range-input-wrapper d-flex justify-content-center align-items-center'>
            <ImageIcon className='image-crop-modal-small-img-icon' />
            <input
              type='range'
              min={1}
              step={0.1}
              max={10}
              value={this.state.scale}
              onChange={this.onChangeScale}
              className='image-crop-modal-range-input'
            />
            <ImageIcon className='image-crop-modal-large-img-icon' />
          </div>
          <div className='text-center'>
            <Button onClick={this.props.onCancel} color='link' className='me-2'>
              Cancel
            </Button>
            <Button onClick={this.onSubmit} color='primary'>
              Save
            </Button>
          </div>
        </NobleModal.Body>
      </NobleModal>
    );
  }
}
